import { UpperCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxFlagComponent } from '@onyx/angular';
import { DictionaryCode } from '../../../enums/dictionary-code';

@Component({
  selector: 'app-country-cell',
  imports: [OnyxFlagComponent, TranslatePipe, UpperCasePipe],
  templateUrl: './country-cell.component.html',
  styleUrl: './country-cell.component.scss',
})
export class CountryCellComponent {
  public readonly countryCode = input.required<string | null>();
  public readonly short = input(false);
  public readonly onlyFlag = input(false);
  public readonly size = input(16);

  protected readonly DictionaryCode = DictionaryCode;
}
